<template>
  <div class="site_subscribe">
    <van-sticky>
      <van-nav-bar title="预约场地" left-arrow @click-left="goback()" />
    </van-sticky>

    <CardBuilding :detailData="detailData"></CardBuilding>

    <div class="subscribe_title">联系人信息</div>

    <!-- 表单 -->
    <van-form
      :show-error="false"
      @submit="onSubmit"
      error-message-align="right"
    >
      <van-cell-group>
        <van-field
          input-align="right"
          required
          v-model="submitData.contactName"
          label="您的姓名"
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入您的姓名' }]"
        />

        <van-field name="radio" label="单选框">
          <template #input>
            <van-radio-group
              v-model="submitData.contactGender"
              direction="horizontal"
            >
              <van-radio
                name="1"
                checked-color="#195ED7"
                @click="submitData.contactGender = '1'"
                >先生</van-radio
              >
              <van-radio
                name="2"
                checked-color="#195ED7"
                @click="submitData.contactGender = '2'"
                >女士</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          input-align="right"
          required
          v-model="submitData.contactNumber"
          label="手机号"
          placeholder="请输入"
          :rules="[
            { required: true, message: '请输入手机号' },
            { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误！' },
          ]"
        />

        <van-field
          input-align="right"
          required
          v-model="submitData.expectedTime"
          label="期望看房时间"
          readonly
          @click="showTime = true"
          placeholder="请选择期望看房时间 "
          :rules="[{ required: true, message: '请选择期望看房时间' }]"
        />

        <div class="subscribe_title">给管家留言</div>

        <van-field
          v-model="submitData.remark"
          rows="2"
          autosize
          type="textarea"
          maxlength="200"
          placeholder="请检单描述你的需求"
          show-word-limit
        />
      </van-cell-group>

      <van-button
        class="m-t25"
        block
        color="#195ED7"
        type="info"
        native-type="submit"
        >提交约看</van-button
      >
    </van-form>

    <van-action-sheet v-model="showTime">
      <van-datetime-picker
        type="datetime"
        title="请选择期望看房时间"
        :min-date="minDate"
        :max-date="maxDate"
        @change="changeShowTime"
        @confirm="confirmShowTime"
        :formatter="formatter"
        @cancel="showTime = false"
      />
    </van-action-sheet>
    
  </div>
</template>

<script>
import {
  Button,
  Icon,
  Image,
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  DatetimePicker,
  ActionSheet,
} from "vant";

import CardBuilding from "./components/CardBuilding";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [DatetimePicker.name]: DatetimePicker,
    [ActionSheet.name]: ActionSheet,
    CardBuilding,
  },
  data() {
    return {
      submitData: {
        site_id: 0,
        contactName: "",
        contactGender: "1",
        contactNumber: "",
        expectedTime: "",
        remark: "",
      },
      minDate: new Date(),
      maxDate: new Date(2030, 10, 1),
      currentDate: new Date(),
      showTime: false,
      confirmTime: "",
      radio: "1",
      detailData: [],
    };
  },

  created() {
    this.submitData.site_id = this.$route.query.id;
    // 个人信息
     this.changePortraitDetail();
    //场地中心-查看
    this.siteUserH5Detail(this.$route.query.id);
  },

  methods: {
    //个人信息-查看
    changePortraitDetail() {
      var that = this;
      that.$api
        .changePortraitDetailAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            that.submitData.contactName = res.data.data.fullName
            that.submitData.contactNumber = res.data.data.contactNumber
            if(res.data.data.gender != ''){
               that.submitData.gender = res.data.data.gender
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
    //场地中心-查看
    siteUserH5Detail(id) {
      var that = this;
      that.$api
        .siteUserH5DetailAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            that.detailData = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    formatter(type, val) {
      if (type === "year") {
        return `${val}`;
      } else if (type === "month") {
        return `${val}`;
      } else if (type === "day") {
        return `${val}`;
      } else if (type === "hour") {
        return ` ${val}`;
      } else if (type === "minute") {
        return ` ${val}:00`;
      }
      return val;
    },

    changeShowTime(picker) {
      var time = picker.getValues();
      this.confirmTime =
        time[0] + "-" + time[1] + "-" + time[2] + " " + time[3] + ":" + time[4];
    },

    confirmShowTime(picker) {
      var that = this;
      setTimeout(function () {
        const modifyTime =  that.dateControlFunc(picker)
        that.submitData.expectedTime = modifyTime
         console.log(that.confirmTime,'这里')
        that.showTime = false;
      }, 500);
    },
    // 标准时间转换
    dateControlFunc(date) {
            const year = date.getFullYear()
            const month = date.getMonth() + 1
            const day = date.getDate()
            const hour = date.getHours()
            const minutes = date.getMinutes()
            const second = date.getSeconds()
            const updateDate = year + '-' + this.fix(month, 2) + '-' + this.fix(day, 2) + ' ' + this.fix(hour, 2) + ':' + this.fix(minutes, 2) + ':' + this.fix(second, 2)
            return updateDate
        },
    fix(num, length) { // 两位补0
        return ('' + num).length < length ? ((new Array(length + 1)).join('0') + num).slice(-length) : '' + num
    },
    //场地中心-查看-预约看房
    onSubmit() {
      var that = this;
      that.$api
        .reservationSaveVisitAPI(that.submitData)
        .then(function (res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "添加成功",
              onClose() {
                //返回上一页
                that.$router.go(-1);
              },
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.site_subscribe {
  .subscribe_title {
    font-size: 14px;
    color: #666;
    padding: 15px 20px;
    background: #f4f3f8;
  }

  .van-radio-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  // 表单
  .van-button {
    width: 90%;
    margin: auto;
    margin-top: 30px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/home/siteSubscribe.vue